import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { GALLERY } from "@/data/content";

export default function Galleria() {
  const [idx, setIdx] = useState(null);
  const open = idx !== null;

  const prev = (e) => { e?.stopPropagation(); setIdx((i) => (i - 1 + GALLERY.length) % GALLERY.length); };
  const next = (e) => { e?.stopPropagation(); setIdx((i) => (i + 1) % GALLERY.length); };

  return (
    <section id="galleria" data-testid="gallery-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Galleria</span>
          <h2 className="mt-3 font-display font-extrabold uppercase tracking-tight text-3xl md:text-4xl">
            I nostri momenti nerazzurri
          </h2>
        </div>

        <div className="mt-10 columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
          {GALLERY.map((g, i) => (
            <motion.button
              key={i}
              data-testid="gallery-photo-item"
              onClick={() => setIdx(i)}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 4) * 0.06 }}
              className="group relative mb-4 block w-full overflow-hidden rounded-2xl break-inside-avoid"
            >
              <img src={g.src} alt={g.caption} className="w-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <span className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <span className="text-white font-bold text-sm">{g.caption}</span>
              </span>
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="gallery-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] flex items-center justify-center bg-black/90 p-4"
            onClick={() => setIdx(null)}
          >
            <button data-testid="gallery-lightbox-close" onClick={() => setIdx(null)} className="absolute top-5 right-5 text-white/80 hover:text-white">
              <X size={30} />
            </button>
            <button data-testid="gallery-lightbox-prev" onClick={prev} className="absolute left-4 md:left-8 text-white/80 hover:text-white p-2">
              <ChevronLeft size={38} />
            </button>
            <motion.figure
              key={idx}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              onClick={(e) => e.stopPropagation()}
              className="max-w-4xl w-full"
            >
              <img src={GALLERY[idx].src} alt={GALLERY[idx].caption} className="w-full max-h-[80vh] object-contain rounded-lg" />
              <figcaption className="mt-3 text-center text-white/80 font-semibold">{GALLERY[idx].caption}</figcaption>
            </motion.figure>
            <button data-testid="gallery-lightbox-next" onClick={next} className="absolute right-4 md:right-8 text-white/80 hover:text-white p-2">
              <ChevronRight size={38} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
